import { extractDataAxios, extractErrorMessageAxios, extractValidationErrorsAxios } from "@/httpClient";
import { createNamespacedHelpers } from "vuex";

const catalyticConverters = {
  namespaced: true,
  state: () => ({
    isFetchedOnce: false,
    data: [],
    isLoading: false,
    // use 'error' and 'validationErrors' together in components, e.g. check 'error' for null then only try to show 'validationErrors'
    error: null,
    validationErrors: [],
    isBeingDeletedId: null,
    pageNumber: 1
  }),

  mutations: {
    SET_PAGE_NUMBER(state, pageNumber) {
      state.pageNumber = pageNumber;
    },
    FETCH_BEGIN(state) {
      state.isLoading = true;
      state.error = null;
    },

    FETCH_SUCCESS(state, payload) {
      state.isFetchedOnce = true;
      state.isLoading = false;
      state.data = payload;
    },

    FETCH_ERROR(state, error) {
      state.isLoading = false;
      state.error = error;
    },

    // FILTER_BY_MANUFACTURER(state, manufacturer) {
    //   state.filtered = state.data.filter(converter => {
    //     return converter.manufacturer === manufacturer
    //   });
    // },

    // FILTER_BY_CODE_OR_GRADE_NAME(state, codeOrGradeName) {
    //   state.filtered = [state.data.find(converter => converter.code === codeOrGradeName)];
    // },

    ADD(state, payload) {
      state.data = [payload, ...state.data];
    },

    EDIT(state, payload) {
      state.data.forEach((converter, index) => {
        if (converter.id === payload.id) {
          state.data[index] = payload;
        }
      });
    },

    DELETE_BEGIN(state, id) {
      state.isBeingDeletedId = id
    },

    DELETE_SUCCESS(state) {
      state.data = state.data.filter(converter => converter.id !== state.isBeingDeletedId);
      state.isBeingDeletedId = null;
    },

    DELETE_ERROR(state, error) {
      state.isBeingDeletedId = null;
      const errorToShow = 'Failed to delete the Catalytic Converter. ' + error;
      // TODO: add the error here to global snackbar queue
    }
  },

  actions: {
    async fetch({ commit }) {
      commit('FETCH_BEGIN');
      try {
        const data = extractDataAxios(await window.axios.get('/api/catalytic-converters'));
        if (data) {
          commit('FETCH_SUCCESS', data);
        }
      }
      catch (e) {
        console.error(e);
        commit('FETCH_ERROR', extractErrorMessageAxios(e));
      }
    },

    async delete({ commit }, id) {
      commit('DELETE_BEGIN', id);
      try {
        await window.axios.delete('/api/catalytic-converters/' + id);
          commit('DELETE_SUCCESS');
      }
      catch (e) {
        console.error(e);
        commit('DELETE_ERROR', extractErrorMessageAxios(e));
      }
    },
  },
}

const { mapState, mapActions, mapMutations } = createNamespacedHelpers('catalyticConverters');

export { mapState, mapActions, mapMutations };

export default catalyticConverters;